"use strict";

// This script will need to be added after Coveo loads
window.addEventListener('DOMContentLoaded', function (event) {
  var servicesContainer = document.querySelector('.services-listing');
  var facetValueItems = document.querySelectorAll('.services-listing .services-facet-values li a.letter-select');
  if (servicesContainer) {
    facetValueItems.forEach(function (item) {
      // const firstfacetValue = document.querySelector('.services-listing .services-facet-values li a.letter-select');
      // firstfacetValue.classList.add('active-facet');

      item.addEventListener('click', function (e) {
        if (item.classList.contains('active-facet')) {
          this.classList.remove('active-facet');
        } else {
          facetValueItems.forEach(function (facet) {
            facet.classList.remove('active-facet');
          });
          this.classList.add('active-facet');
        }
      });
    });
  }
});